export function DialogOverrides() {
  return {
    Dialog: {
      styleOverrides: {
        sx: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
      },
    },
  }
}
